module.exports = __webpack_public_path__ + "img/clone-icon.4159ab41.svg";